<template>
<svg width="25px" height="21px" viewBox="0 0 25 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <title>video-off</title>
    <desc>Created with Sketch.</desc>
    <g id="video-and-cobrowsing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Artboard-Copy" transform="translate(-609.000000, -390.000000)">
            <g id="video-off" transform="translate(610.000000, 391.000000)">
                <path d="M3,3 L15.372093,3 C16.4766625,3 17.372093,3.8954305 17.372093,5 L17.372093,8 L17.372093,8 L21.4206751,5.1224954 C21.8708405,4.80254308 22.4951444,4.9081017 22.8150967,5.35826718 C22.9353766,5.52749823 23,5.72997127 23,5.9375921 L23,14.0624079 C23,14.6146926 22.5522847,15.0624079 22,15.0624079 C21.7923792,15.0624079 21.5899061,14.9977845 21.4206751,14.8775046 L17.372093,12 L17.372093,12 L17.372093,15 C17.372093,16.1045695 16.4766625,17 15.372093,17 L3,17 C1.8954305,17 1,16.1045695 1,15 L1,5 C1,3.8954305 1.8954305,3 3,3 Z" id="Rectangle" stroke="#ffffff"></path>
                <line x1="0.5" y1="0.5" x2="22.5" y2="18.5" id="Line-3" stroke="#F44336" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
            </g>
        </g>
    </g>
</svg>
</template>
